import { STAGE } from 'config/envVars';

/**
 * Supabase environment configuration.
 *
 * One Supabase project (tenant) per environment: lower environments share
 * the dev tenant, while stage and prod each get a dedicated one.
 *
 * PLACEHOLDER values: replace these once the real project URLs and keys
 * are available.
 *
 * The publishable (anon) key is NOT a secret — it is designed to be public
 * and embedded in client-side code.
 * See: https://supabase.com/docs/guides/api/api-keys
 */

export type SupabaseEnvironment =
  | 'local'
  | 'ci'
  | 'qa'
  | 'dev'
  | 'stage'
  | 'prod';

export interface SupabaseConfig {
  url: string;
  publishableKey: string;
}

const SUPABASE_CONFIGS: Record<SupabaseEnvironment, SupabaseConfig> = {
  local: {
    url: 'https://PLACEHOLDER-dev.supabase.co',
    publishableKey: 'sb_publishable_PLACEHOLDER_DEV',
  },
  ci: {
    url: 'https://PLACEHOLDER-dev.supabase.co',
    publishableKey: 'sb_publishable_PLACEHOLDER_DEV',
  },
  qa: {
    url: 'https://PLACEHOLDER-dev.supabase.co',
    publishableKey: 'sb_publishable_PLACEHOLDER_DEV',
  },
  dev: {
    url: 'https://PLACEHOLDER-dev.supabase.co',
    publishableKey: 'sb_publishable_PLACEHOLDER_DEV',
  },
  stage: {
    url: 'https://PLACEHOLDER-stage.supabase.co',
    publishableKey: 'sb_publishable_PLACEHOLDER_STAGE',
  },
  prod: {
    url: 'https://PLACEHOLDER-prod.supabase.co',
    publishableKey: 'sb_publishable_PLACEHOLDER_PROD',
  },
};

export const getSupabaseConfig = (
  stage: SupabaseEnvironment = STAGE as SupabaseEnvironment
): SupabaseConfig => SUPABASE_CONFIGS[stage] ?? SUPABASE_CONFIGS.local;
